export function formatIntegerNumber(points: number) {
  let numberInString = points.toString();

  const parts = numberInString.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  numberInString = parts.join('.');

  return numberInString;
}
